import EmbeddedVideoPlayer from './EmbeddedVideoPlayer';

const els = document.querySelectorAll('.js-embedded-video-player');

for (let el of els) {
    new EmbeddedVideoPlayer(el);
}
